"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@/utils/cn";
import { useState } from "react";
import { Label, Text } from "react-aria-components";
interface ButtonGroupProps<T = unknown> {
  label?: string;
  labelClassName?: string;
  options: {
    label: string;
    value: T;
  }[];
  value: T | T[];
  onChange: (value: T[] | T | null) => void;
  multiple?: boolean;
  expandable?: boolean;
  initialCount?: number;
  increment?: number;
  description?: string;
  errorMessage?: string;
  className?: string;
}
export const ButtonGroup = t0 => {
  const $ = _c(42);
  const {
    label,
    labelClassName,
    options,
    value,
    onChange,
    multiple: t1,
    expandable: t2,
    initialCount: t3,
    increment: t4,
    description,
    errorMessage,
    className
  } = t0;
  const multiple = t1 === undefined ? false : t1;
  const expandable = t2 === undefined ? false : t2;
  const initialCount = t3 === undefined ? 3 : t3;
  const increment = t4 === undefined ? 3 : t4;
  const [visibleCount, setVisibleCount] = useState(initialCount);
  let t5;
  if ($[0] !== expandable || $[1] !== options || $[2] !== visibleCount) {
    t5 = expandable ? options.slice(0, visibleCount) : options;
    $[0] = expandable;
    $[1] = options;
    $[2] = visibleCount;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const visibleOptions = t5;
  const hasMore = expandable && visibleCount < options.length;
  let t6;
  if ($[4] !== increment) {
    t6 = () => setVisibleCount(c => c + increment);
    $[4] = increment;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const handleShowMore = t6;
  let t7;
  if ($[6] !== multiple || $[7] !== value) {
    t7 = v => multiple ? Array.isArray(value) && value.includes(v) : value === v;
    $[6] = multiple;
    $[7] = value;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const isSelected = t7;
  let t8;
  if ($[9] !== isSelected || $[10] !== multiple || $[11] !== onChange || $[12] !== value) {
    t8 = v_0 => {
      let newValue;
      if (multiple) {
        if (Array.isArray(value)) {
          newValue = isSelected(v_0) ? value.filter(x => x !== v_0) : [...(Array.isArray(value) ? value : []), v_0];
        } else {
          newValue = [v_0];
        }
      } else {
        newValue = isSelected(v_0) ? null : v_0;
      }
      onChange(newValue);
    };
    $[9] = isSelected;
    $[10] = multiple;
    $[11] = onChange;
    $[12] = value;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const toggleValue = t8;
  let t9;
  if ($[14] !== label || $[15] !== labelClassName) {
    t9 = label && <Label className={cn("text-title-medium", labelClassName)}>{label}</Label>;
    $[14] = label;
    $[15] = labelClassName;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const t10 = className ?? "";
  let t11;
  if ($[17] !== t10) {
    t11 = cn("flex flex-wrap items-center", t10);
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== isSelected || $[20] !== toggleValue || $[21] !== visibleOptions) {
    let t13;
    if ($[23] !== isSelected || $[24] !== toggleValue) {
      t13 = (o, index) => <button type="button" key={`${index}-${String(o.value)}`} onClick={() => toggleValue(o.value)} className={cn("px-4 py-3 text-body shadow-sm hover:bg-neutral-300 cursor-pointer", isSelected(o.value) ? "bg-primary-400" : "bg-white")}>{o.label}</button>;
      $[23] = isSelected;
      $[24] = toggleValue;
      $[25] = t13;
    } else {
      t13 = $[25];
    }
    t12 = visibleOptions.map(t13);
    $[19] = isSelected;
    $[20] = toggleValue;
    $[21] = visibleOptions;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[26] !== handleShowMore || $[27] !== hasMore) {
    t13 = hasMore && <button type="button" onClick={handleShowMore} className="px-4 py-3 text-body shadow-sm hover:bg-neutral-300 cursor-pointer">Show More</button>;
    $[26] = handleShowMore;
    $[27] = hasMore;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t11 || $[30] !== t12 || $[31] !== t13) {
    t14 = <div className={t11}>{t12}{t13}</div>;
    $[29] = t11;
    $[30] = t12;
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== description) {
    t15 = description && <Text slot="description" className="text-xs text-muted-foreground">{description}</Text>;
    $[33] = description;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== errorMessage) {
    t16 = errorMessage && <Text slot="errorMessage" className="text-sm font-medium text-destructive">{errorMessage}</Text>;
    $[35] = errorMessage;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t14 || $[38] !== t15 || $[39] !== t16 || $[40] !== t9) {
    t17 = <div className="group flex flex-col py-1 my-1 gap-1.5">{t9}{t14}{t15}{t16}</div>;
    $[37] = t14;
    $[38] = t15;
    $[39] = t16;
    $[40] = t9;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  return t17;
};